import Box from '@mui/material/Box'
import axios from 'axios'
import { useEffect, useState, Fragment } from 'react'
import Image from 'mui-image'
// import { Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
// import { Swiper, SwiperSlide } from 'swiper/react'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/react-splide/css'

import ArrowCircleLeft from '../../assets/ArrowCircleLeft.svg'
import ArrowCircleRight from '../../assets/ArrowCircleRight.svg'
import okpalaFarms from '../../assets/okpalaFarms.png'
import Heading from '../Heading'
import Paragraph from '../Paragraph'

export default function OkpalaFarms () {
  const [okpalaImages, setOkpalaImages] = useState([])
  const [hoverImage, setHoverImage] = useState({})

  const getGalleries = async () => {
    try {
      const getGalleryImages = await axios.get(
        `${process.env.REACT_APP_PROD_MODE === 'test'
          ? process.env.REACT_APP_API_URL_TEST
          : process.env.REACT_APP_API_URL_LIVE}/admin/get-images/igorOkpala`

      )

      setOkpalaImages([...getGalleryImages.data.allImages])
    } catch (error) {
    }
  }

  useEffect(() => {
    getGalleries()
  }, [])

  return (
    <>
      <Box sx={{
        display: { md: 'flex' },
        justifyContent: { md: 'space-between' },
        paddingTop: { xs: '50px', md: '200px' },
        paddingBottom: { md: '100px' }
      }}
      >
        <Box sx={{ paddingTop: '30px' }}>
          <Heading
            fontWeight='bold'
            color='primary.main'
            fontSize={{ xs: '30px', md: '48px' }}
          >
            Ngor Okpala Farm
          </Heading>
          <Paragraph
            paddingTop='20px'
            fontSize={{ xs: '12px', md: '16px' }}
            textAlign='left'
            lineHeight={{ xs: '20px', md: '32px' }}
            width={{ xs: '300px', md: '500px' }}
            paddingBottom={{ xs: '20px', md: '0px' }}
          >
            Following the resounding success of Naze Farms, Onecultur's enterprising agricultural project now directs its attention to Ngor Okpala.
          </Paragraph>
          <Paragraph
            // paddingTop='20px'
            fontSize={{ xs: '12px', md: '16px' }}
            textAlign='left'
            lineHeight={{ xs: '20px', md: '32px' }}
            width={{ xs: '300px', md: '500px' }}
            paddingBottom={{ xs: '20px', md: '0px' }}
          >
            Expanding across a sprawling 50 hectares of fertile terrain, the opportunities for growth are boundless. Phase 1 of the Ngor Okpala farms has already been initiated, with a substantial 25 hectares cleared as of 2023. This cultivated land is now primed for nurturing a diverse array of crops, including:
          </Paragraph>
          <Paragraph
            // paddingTop='20px'
            fontSize={{ xs: '12px', md: '16px' }}
            textAlign='left'
            lineHeight={{ xs: '20px', md: '32px' }}
            width={{ xs: '300px', md: '500px' }}
            paddingBottom={{ xs: '20px', md: '0px' }}
          >
            <ul>
              <li> Maize</li>
              <li> Sweet potato</li>
              <li>Tomato</li>
              <li>Paw Paw</li>
              <li> Ugwu</li>
              <li>Cucumber</li>
            </ul>
            Furthermore, we have ventured into animal farming with the following projects:
            <ul>
              <li>An apiculture endeavor that houses over 3000 bees</li>
              <li> Aquaculture featuring 16 concrete ponds and an extra-large earthen pond</li>
              <li> A dedicated ranch catering to goats, cattle, and pigs</li>
            </ul>
          </Paragraph>
        </Box>
        <Box>
          <Image showLoading alt='' src={okpalaFarms} width='100%' height='100%' />
        </Box>
      </Box>
      <Box sx={{ paddingTop: { xs: '40px', md: '50px' } }}>
        {okpalaImages.length > 0 &&
          <Paragraph
            display='flex'
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            color='primary.main'
            fontWeight='bold'
            fontSize={{ xs: '25px', md: '48px' }}
            paddingBottom={{ xs: '15px', md: '25px' }}
            textAlign={{ xs: 'center', md: 'left' }}
          >
            Images of Ngor Okpala Farm
          </Paragraph>}
        {okpalaImages.length > 0 &&
          <>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Splide
                hasTrack={false}
                options={{
                  rewind: true,
                  autoplay: true,
                  type: 'loop',
                  perPage: 6,
                  pagination: false,
                  gap: '1rem'

                }}
              >
                <SplideTrack>
                  {okpalaImages.length > 0 && okpalaImages.map(({ image }, index) => (
                    <SplideSlide
                      onMouseLeave={() => setHoverImage({ status: false, index })}
                      onMouseEnter={() => setHoverImage({ status: true, index })}
                      style={{
                        width: hoverImage.status && hoverImage.index === index ? '30%' : '15%',
                        transition: 'width 0.3s ease-in-out'
                      }}
                      key={index}
                    >
                      <Box>
                        <Box>
                          <Image src={image} alt={index} width='100%' height='100%' />
                        </Box>
                      </Box>
                    </SplideSlide>
                  ))}
                </SplideTrack>
                <div className='splide__arrows'>
                  <button className='splide__arrow splide__arrow--prev'>
                    <img alt='' src={ArrowCircleLeft} width='100%' height='100%' />
                  </button>
                  <button className='splide__arrow splide__arrow--next'>
                    <img alt='' src={ArrowCircleRight} width='100%' height='100%' />
                  </button>
                </div>
              </Splide>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
              <Splide
                hasTrack={false}
                options={{
                  rewind: true,
                  autoplay: true,
                  type: 'loop',
                  perPage: 1,
                  pagination: false,
                  gap: '1rem'

                }}
              >
                <SplideTrack>
                  {okpalaImages.length > 0 && okpalaImages.map(({ image }, index) => (
                    <SplideSlide
                      onMouseLeave={() => setHoverImage({ status: false, index })}
                      onMouseEnter={() => setHoverImage({ status: true, index })}
                      style={{
                        width: hoverImage.status && hoverImage.index === index ? '30%' : '15%',
                        transition: 'width 0.3s ease-in-out'
                      }}
                      key={index}
                    >
                      <Box>
                        <Box>
                          <Image src={image} alt={index} width='100%' height='100%' />
                        </Box>
                      </Box>
                    </SplideSlide>
                  ))}
                </SplideTrack>
                <div className='splide__arrows'>
                  <button className='splide__arrow splide__arrow--prev'>
                    <img alt='' src={ArrowCircleLeft} width='100%' height='100%' />
                  </button>
                  <button className='splide__arrow splide__arrow--next'>
                    <img alt='' src={ArrowCircleRight} width='100%' height='100%' />
                  </button>
                </div>
              </Splide>
            </Box>
          </>}
      </Box>
    </>
  )
}
